import lbLogo from "../Assets/Projects/lb.png"
import github from "../Assets/Projects/github.png"
import bst from "../Assets/Projects/BST.png"
import cell from "../Assets/Projects/cell.png"
import nsdi from "../Assets/Projects/nsdi25.png"
import bloom_filter from "../Assets/Projects/Bloom_filter.png"


export const project_data = [
        {
                title: "Distributed System Paper",
                description: "2025 NSDI accepcted",
                link: "https://www.usenix.org/conference/nsdi25/presentation/bantikyan",
                img: nsdi
        },
        {
                title: "Software engineer",
                description: "@ CytoAurora Biotechnologies",
                link: "https://www.cytoaurora.com/en",
                img: cell
        },
        {
                title: "Linking Book",
                description:"Social platform" ,
                link:"https://github.com/teyenc/linking-book",
                img: lbLogo
        },
        {
                title: "GitHub",
                description:"Data & Code",
                link:"https://github.com/teyenc",
                img: github
        },
]

export const portfolio_data = [
        {
                title: "2025 NSDI accepted paper",
                description: "Pineapple: A system that unifies Multi-Paxos and atomic shared registers using logical timestamps to improve throughput and latency by offloading reads and writes to non-leader nodes, addressing bottlenecks in leader-based consensus systems",
                link: "https://www.usenix.org/conference/nsdi25/presentation/bantikyan",
                img: nsdi,
                authors: "Tigran Bantikyan, Jonathan Zarnstorff, Te-Yen Chou, Lewis Tseng, Roberto Palmieri",
                type: "publication"
        },
        {
                title: "Binary Search Tree - TLA+",
                description:"TLA+ specification for a Binary Search Tree (BST) using a finite set of natural numbers. The implementation supports basic operations like insertion and deletion while maintaining BST properties." ,
                link:"https://github.com/teyenc/BinarySearchTree_TLAplus",
                img: bst,
                authors: "Te-Yen Chou",
                type: "project"
        },
        {
                title: "Bloom filter in C++",
                description:"A C++ Bloom Filter implementation: Trading perfect accuracy for 99%+ memory savings, with configurable false-positive rates." ,
                link:"https://github.com/teyenc/bloom-filter-practice",
                img: bloom_filter,
                authors: "Te-Yen Chou",
                type: "project"
        },
        {
                title: "Linking Book (2021)",
                description: "Mobile social platform for people to share link, text, and images",
                link: "https://github.com/teyenc/linking-book",
                img: lbLogo,
                authors: "Te-Yen Chou",
                type: "project"
        },
]

export const magic_imgs = [
        {
                img:"https://andy-website-image.s3.us-east-2.amazonaws.com/IMG_3735.JPG"
        },
        {
                img:"https://andy-website-image.s3.us-east-2.amazonaws.com/IMG_2523.JPG"
        },
        {
                img:"https://andy-website-image.s3.us-east-2.amazonaws.com/magic1.JPG"
        },
        {
                img:"https://andy-website-image.s3.us-east-2.amazonaws.com/basketball-min.png"
        }
]

export const magic_profile = "https://andy-website-image.s3.us-east-2.amazonaws.com/14481798_1159521720796821_8125915069111156951_o.jpeg"

export const blog_data = [
  {
    id: 3,
    title: "Reflection on Spring 2025 Database System",
    slug: "reflections-on-spring-2025-15-445-database-system",
    date: "2025-04-23",
    excerpt: "My takeaways from CMU's 15-445 Database System course—buffer pool manager, B+ trees, MVCC, and more.",
    file: "/posts/reflections-on-spring-2025-15-445-database-system.md"
  }
];

export const publication_data = [
  {
    id: 1,
    title: "Pineapple: A system that unifies Multi-Paxos and atomic shared registers using logical timestamps",
    venue: "2025 NSDI",
    link: "https://www.usenix.org/conference/nsdi25/presentation/bantikyan",
    authors: "Tigran Bantikyan, Jonathan Zarnstorff, Te-Yen Chou, Lewis Tseng, Roberto Palmieri"
  }
];